import { Permissions } from "api/role/addRole";

/**
 * Client-side permission utility
 * Creates a complete permission structure with all values set to a specified boolean
 */
export const getCompletePermissions = (allTrue = true): Permissions => ({
  dashboard: allTrue,
  connect: {
    chat: allTrue,
    meeting: allTrue,
  },
  projects: allTrue,
  allProjects: allTrue,
  notifications: allTrue,
  ourClients: allTrue,
  userProfile: allTrue,
  holidays: allTrue,
  attendance: {
    admin: allTrue,
    employee: allTrue,
  },
  employees: {
    department: allTrue,
    leaveEmployees: allTrue,
    adminLeave: allTrue,
    leaveConfiguration: allTrue,
  },
  reports: {
    leaveReports: allTrue,
    attendanceReports: allTrue,
  },
  adminSettings: allTrue,
  superAdminPanel: allTrue,
});
